import { sel } from '../utils'
// import parser from 'any-date-parser'

export default function countDown() {
  const date$ = sel('.even-intro__mod__h') // e.g. March 19, 2025, 1:30-3:00pm, or March 19, 2025, 1:30am-3:00pm
  if (!date$) return
  const day$ = sel('#event-day')

  const hr$ = sel('#event-hr')
  const min$ = sel('#event-min')
  const sec$ = sel('#event-sec')
  // console.log('Countdown date:', parser.fromString(date$.textContent))

  // Parse date string like "March 19, 2025, 1:30am-3:00pm" or "March 19, 2025, 1:30-3:00pm"
  function parseEventDateTime(dateString) {
    try {
      // Extract the date part and the start time
      const parts = dateString.trim().split(',')
      if (parts.length < 3) {
        throw new Error(`Invalid date format: ${dateString}`)
      }

      // Get the date portion (e.g. "March 19, 2025")
      const datePart = parts[0] + ',' + parts[1]

      // Get the time part (e.g. " 1:30am-3:00pm" or " 1:30-3:00pm")
      const timePart = parts[2].trim()

      // Extract the start time (before the dash)
      let startTime = timePart.split('-')[0].trim()

      // If no am/pm in startTime but exists in full string, extract from end
      if (!startTime.includes('am') && !startTime.includes('pm') && (timePart.includes('am') || timePart.includes('pm'))) {
        // Extract am/pm from the end time
        const amPm = timePart.match(/[ap]m\b/i)
        if (amPm) {
          startTime += amPm[0]
        }
      }

      // Combine date and start time
      const dateTimeString = `${datePart}, ${startTime}`
      // console.log('Parsed date time:', dateTimeString)

      // Manual date parsing as a fallback if Date constructor fails
      let dateObj = new Date(dateTimeString)

      if (isNaN(dateObj.getTime())) {
        // Parse manually if the Date constructor fails
        const monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']

        // Extract date components
        const dateMatch = datePart.match(/([a-z]+)\s+(\d{1,2}),\s+(\d{4})/i)
        if (dateMatch) {
          const monthName = dateMatch[1].toLowerCase()
          const day = parseInt(dateMatch[2], 10)
          const year = parseInt(dateMatch[3], 10)
          const monthIndex = monthNames.indexOf(monthName)

          // Extract time components
          let hours = 0
          let minutes = 0

          const timeMatch = startTime.match(/(\d{1,2}):(\d{2})([ap]m)?/i)
          if (timeMatch) {
            hours = parseInt(timeMatch[1], 10)
            minutes = parseInt(timeMatch[2], 10)

            // Handle AM/PM
            const isPM = /pm/i.test(timeMatch[3] || startTime)
            if (isPM && hours < 12) hours += 12
            if (!isPM && hours === 12) hours = 0
          }

          // Create date using specific components
          dateObj = new Date(year, monthIndex, day, hours, minutes, 0)
          // console.log('Manually parsed components:', { monthName, monthIndex, day, year, hours, minutes })
        }
      }

      if (isNaN(dateObj.getTime())) {
        throw new Error(`Failed to parse date: ${dateTimeString}`)
      }

      return dateObj
    } catch (error) {
      console.error('Error parsing date:', error)
      // Return a date far in the future to prevent 'EXPIRED' message as fallback
      const futureDate = new Date()
      futureDate.setFullYear(futureDate.getFullYear() + 10)
      return futureDate
    }
  }

  // Use the new parsing function
  const date = parseEventDateTime(date$.textContent)
  // console.log('Parsed event date:', date)

  const countDownDate = date.getTime()
  // console.log('Countdown to:', date$.textContent)

  const x = setInterval(() => {
    // Get today's date and time
    const now = new Date().getTime()

    // Find the distance between now and the count down date
    const distance = countDownDate - now

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)

    // Display the result in the elements with id="demo"
    day$.textContent = days
    hr$.textContent = hours
    min$.textContent = minutes
    sec$.textContent = seconds

    // If the count down is over, write some text
    if (distance < 0) {
      clearInterval(x)
      day$.textContent = 'EXPIRED'
      hr$.textContent = ''
      min$.textContent = ''
      sec$.textContent = ''
    }
  }, 1000)
}
